(function ($) {
    if ($('.contact-us').length) {
        // $('.js-example-basic-single').select2();
    }
})(jQuery);